import * as React from "react";

const ComingSoon: React.SFC = () => <div>Dashboard Coming Soon!</div>;
export default ComingSoon;



// WEBPACK FOOTER //
// ./src/components/admin/Dashboard.tsx